import Yup from "../../Yup";
import { password } from "../../helpers/formSchemaHelper";

const DoPasswordResetSchema = Yup.object().shape({
  password: password,
});

export default DoPasswordResetSchema;
